import "./fetcher.js";
import "#/shared/api/api-host-global.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Helpers ??= {};

AppointmentBooking.SlotPickerModal.Helpers.AppointmentGridDateFetcher = class AppointmentGridDateFetcher extends (
  AppointmentBooking.SlotPickerModal.Helpers.Fetcher
) {
  constructor({ api, processor }) {
    super();
    this.api = api;
    this.processor = processor;
  }
};

AppointmentBooking.SlotPickerModal.Helpers.AppointmentGridDateFetcher.prototype.endpoint = window.Sparkle.apiHost
  ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.ehrAppointmentSlots
  : undefined;
